import styled from 'styled-components'
import { deviceDF } from 'assets/breakPoints'

export const InputRoot = styled.div`
   display: flex;
   position: relative;
   justify-content: space-between;
   color: hsl(0deg 0% 0% / 87%);
   font-size: 1rem;
   font-family: "Roboto", "Helvetica", "Arial", sans-serif;
   align-items: center;
   font-weight: 400;
   line-height: 1.1876em;  
   margin: 30px auto;
   width: 100%;
   gap: 10px;
   @media ${deviceDF.mobileL} {
      margin: 20px auto;
   }
`

export const InputText = styled.input`
   width: 100%;
   border-left-style: none;
   border-right-style: none;
   border-top-style: none;
   border-bottom-color: ${props =>
      props.requiredField === 'error'
         ? "#e63946"
         : "#999999"};
   font-size: 18px;
   outline: none;
   margin: 0px 32px;
   display: block;
   padding: 2px 3px;
   min-width: 0;
   -webkit-appearance: none;
   box-sizing: content-box;
   letter-spacing: inherit;
   background: transparent;
   font-family: "Red Hat Display", Sans-serif;
   &::placeholder {
      color: #6c757d;
      font-family: "Red Hat Display", Sans-serif;
   }
`
export const ImageStyled = styled.img`
   width: 25px;
   height: 25px;
   position: absolute;
   top: 0;
`

export const SpanStyled = styled.span`
display: flex;
  justify-content: center;
  width: 40px;
   height: 30px;
  padding: 0;
  right: 0;
  top: 0;
  position: absolute;
  font-size: 16px;
  border-radius: 0 20px 20px 0;
  border: 1px solid #999999;
  transform: translate(1px, -1px);
  color: #fff;
  background-color: hsl(0deg 0% 70%);
  &:active {
    background-color: #6b6b6b;
  }
  transition: background 0.3s ease, border 0.3s ease, color 0.3s ease;
  align-items: center;
  cursor: pointer;

  @media ${deviceDF.mobileL} {
    height: 30px;
  }
  @media ${deviceDF.mobileM} {
   height: 30px;
  }
`